module.exports = __webpack_public_path__ + "img/hipster_black_top-400x520.675d6e9c.jpg";